export default __webpack_public_path__ + "static/media/white.e6ef725e.png";